<div
  v-if="message"
  class="position-fixed bottom-0 end-0 p-3"
  style="z-index: 1080;"
>
  <div
    class="toast show align-items-center border-0 shadow"
    :class="variant_class"
    role="alert"
    :aria-live="aria_live"
    aria-atomic="true"
  >
    <div class="d-flex">
      <div class="toast-body d-flex align-items-center gap-2">
        <i :class="icon_class"></i>
        <span>{{ message }}</span>
      </div>
      <button
        type="button"
        class="btn-close btn-close-white me-2 m-auto"
        aria-label="Close"
        @click="dismiss"
      ></button>
    </div>
  </div>
</div>
